import React, { useState, useRef } from 'react';
import { Card } from "primereact/card";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";
import { useForm, Controller } from "react-hook-form";
import { login } from "../apis/Authentication";
import constants from "../constants";
import { useAuthStore } from "../store/AuthStore";
import { Link, Redirect, useRouter, useRouterActions } from "react-resource-router";
import PasswordController from "../components/controllers/PasswordController";
import utils from "../utils";
import { getSchoolsByOwner, getSchoolsByUser } from "../apis/School";
import { useSchoolStore } from "../store/SchoolStore";
import { useResourcesStore } from '../store/ResourcesStore';

const Login = ({ toast }) => {

  const toastL = useRef(toast);
  const { errors, handleSubmit, control } = useForm();
  const [state, actions] = useAuthStore();
  const [,schoolActins] = useSchoolStore();
  const [resState, resActions] = useResourcesStore()
  const { push } = useRouterActions();
  const [loading, setLoading] = useState(false);

  const onSubmit = async (data) => {
    
    if (loading) return;

    setLoading(true);

    const { username, password } = data;

    try {

      const loginRes = await login({ username, password });      
      const resOS = await getSchoolsByOwner(loginRes.data.user.id);
      const resUS = await getSchoolsByUser(loginRes.data.user.id);

      const userIsOwner = (loginRes.data.role && Array.isArray(loginRes.data.role) && loginRes.data.role.find((p) => p.name === "owner" || p.name === "Owner")) != null;

      actions.onLoginSuccess({ id: loginRes.data.user.id, accessToken: loginRes.data.accessToken, refreshToken: loginRes.data.refreshToken, username: loginRes.data.user.username, firstName: loginRes.data.user.firstName, lastName: loginRes.data.user.lastName, email: loginRes.data.user.email, roles: loginRes.data.role, isOwner: userIsOwner, isAuthenticated: true });

      resActions.onOwnerSchools(resOS.data);

      resActions.onUserSchools(resUS.data);

      setLoading(false);

      let detail;

      if(!(resUS.data && Array.isArray(resUS.data) && resUS.data.length > 0) && !userIsOwner){
        detail = utils.toastCallback({ severity: "info", summary: "Login Successful", detail: "But you are not in a school or you don't own a school" });
        toastL.current.show(detail);
      }

      //push(constants.routes.splashscreen); 
      
    } catch (err) {

      setLoading(false);

      let detail;

      if (err.responseCodeDescription) {
        detail = utils.toastCallback({ severity: "error", summary: "Login Error", detail: err.responseCodeDescription });
      } 
      else {
        detail = utils.toastCallback({ severity: "error", summary: "Network Error", detail: constants.networkErrorMessage });
      }

      toastL.current.show(detail);

    }
  };


  if (state.isAuthenticated) {

    let path;

    if(state.isOwner || (Array.isArray(resState.userSchools) && resState.userSchools.length > 1)) {
      path = constants.routes.welcome;
    }
    else{
      
      if(!resState.userSchools || (!Array.isArray(resState.userSchools) && resState.userSchools.length <= 0))
      {
        path = constants.routes.logout;
      }
      else
      {
        schoolActins.onSelectSchool({
          schoolId: resState.userSchools[0]['id'],
          schoolName: resState.userSchools[0]['name'],
          schoolDescription: resState.userSchools[0]['description'],
          roles: resState.userSchools[0]['roles'],
          categories: resState.userSchools[0]['categories']
        });

        path = constants.routes.dashboard;
      } 
    }

    path = sessionStorage.getItem("path") || path;

    sessionStorage.removeItem("path");

    return <Redirect to={path} toast={toastL} />;
  }

  return (
    <div className="flex align-items-center justify-content-center" style={{ height: "97vh" }}>
      <Toast ref={toastL} />
      <Card
        header={
          <div className="text-center mb-2 mt-5">
            {/* <img src="/demo/images/blocks/logos/hyper.svg" alt="hyper" height={50} className="mb-3" /> */}
            <div className="text-900 text-3xl font-medium mb-3">Welcome Back</div>
            <span className="text-600 font-medium line-height-3">Don't have an account?</span>
            {/* TODO: add create page */}
            <a className="font-medium no-underline ml-2 text-blue-500 cursor-pointer" href={constants.routes.home}>Create today!</a>
        </div>
        }
        style={{ width: 320 }}>
        <form className="p-d-flex p-flex-column" onSubmit={handleSubmit( async (e) => await onSubmit(e) )}>
          <div style={{ marginBottom: 15 }}>
            <Controller
              name="username"
              control={control}
              rules={{ required: true }}
              defaultValue=""
              render={props => (
                <InputText
                  style={{ marginBottom: 5, width: "100%" }}
                  placeholder="Username"
                  value={props.value}
                  onChange={e => props.onChange(e.target.value)}
                />
              )}
            />
            {errors.Username && <span style={{ fontSize: 12, color: "red" }}>Username is required</span>}
          </div>
          <div style={{ marginBottom: 15 }}>
            <Controller
              name="password"
              control={control}
              rules={{ required: true }}
              defaultValue=""
              render={props => (
                <PasswordController
                  placeholder="Password"
                  value={props.value}
                  onChange={e => props.onChange(e.target.value)}
                />
              )}
            />
            {errors.password && (
              <span style={{ fontSize: 12, color: "red" }}>Password is required</span>
            )}
          </div>
          <Button
            type="submit"
            label={!loading ? "Login" : null}
            icon={loading ? "pi pi-spin pi-spinner" : null}
            style={{ width: "100%" }}
          />
        </form>
        <Link href={constants.routes.forgotpassword} className="auth-link">
          <p style={{ marginBottom: 0, marginTop: 20, fontSize: 14 }}>Forgot Password</p>
        </Link>
      </Card>
    </div>
  );

};

export default Login;
